export const COUNTRY_LIST = [
    'ad', 'ae', 'af', 'ag', 'ai', 'al', 'am', 'an', 'ao', 'aq', 'ar', 'as', 'at',
    'au', 'aw', 'ax', 'az', 'ba', 'bb', 'bd', 'be', 'bf', 'bg', 'bh', 'bi', 'bj',
    'bl', 'bm', 'bn', 'bo', 'bq', 'br', 'bs', 'bt', 'bv', 'bw', 'by', 'bz', 'ca',
    'cc', 'cd', 'cf', 'cg', 'ch', 'ci', 'ck', 'cl', 'cm', 'cn', 'co', 'cr', 'cv',
    'cw', 'cx', 'cy', 'cz', 'de', 'dj', 'dk', 'dm', 'do', 'dz', 'ec', 'ee', 'eg',
    'eh', 'er', 'es', 'et', 'fi', 'fj', 'fk', 'fm', 'fo', 'fr', 'ga', 'gb', 'gd',
    'ge', 'gf', 'gg', 'gh', 'gi', 'gl', 'gm', 'gn', 'gp', 'gq', 'gr', 'gs', 'gt',
    'gu', 'gw', 'gy', 'hk', 'hm', 'hn', 'hr', 'ht', 'hu', 'id', 'ie', 'il', 'im',
    'in', 'io', 'iq', 'is', 'it', 'je', 'jm', 'jo', 'jp', 'ke', 'kg', 'kh', 'ki',
    'km', 'kn', 'kr', 'kp', 'kw', 'ky', 'kz', 'la', 'lb', 'lc', 'li', 'lk', 'lr',
    'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me', 'mf', 'mg', 'mh', 'mk', 'ml',
    'mm', 'mn', 'mo', 'mp', 'mq', 'mr', 'ms', 'mt', 'mu', 'mv', 'mw', 'mx', 'my',
    'mz', 'na', 'nc', 'ne', 'nf', 'ng', 'ni', 'nl', 'no', 'np', 'nr', 'nu', 'nz',
    'om', 'pa', 'pe', 'pf', 'pg', 'ph', 'pk', 'pl', 'pm', 'pn', 'pr', 'ps', 'pt',
    'pw', 'py', 'qa', 're', 'ro', 'rs', 'ru', 'rw', 'sa', 'sb', 'sc', 'se', 'sg',
    'sh', 'si', 'sj', 'sk', 'sl', 'sm', 'sn', 'so', 'sr', 'ss', 'st', 'sv', 'sx',
    'sz', 'tc', 'td', 'tf', 'tg', 'th', 'tj', 'tk', 'tl', 'tm', 'tn', 'to', 'tr',
    'tt', 'tv', 'tw', 'tz', 'ua', 'ug', 'um', 'us', 'uy', 'uz', 'va', 'vc', 've',
    'vg', 'vi', 'vn', 'vu', 'wf', 'ws', 'xk', 'ye', 'yt', 'za', 'zm', 'zw', 'ir',
    'ls', 'ac', 'cu', 'sy', 'sd',
];

export const LANGUAGES = ['aa', 'ab', 'ae', 'af', 'ak', 'am', 'an', 'ar', 'as', 'av', 'ay', 'az',
    'ba', 'be', 'bg', 'bh', 'bi', 'bm', 'bn', 'bo', 'br', 'bs', 'ca', 'ce', 'ch', 'co', 'cr',
    'cs', 'cu', 'cv', 'cy', 'da', 'de', 'dv', 'dz', 'ee', 'el', 'en', 'eo', 'es', 'et', 'eu',
    'fa', 'ff', 'fi', 'fj', 'fo', 'fr', 'fy', 'ga', 'gd', 'gl', 'gn', 'gu', 'gv', 'ha', 'he',
    'hi', 'ho', 'hr', 'ht', 'hu', 'hy', 'hz', 'ia', 'id', 'ie', 'ig', 'ii', 'ik', 'io', 'is',
    'it', 'iu', 'ja', 'jv', 'ka', 'kg', 'ki', 'kj', 'kk', 'kl', 'km', 'kn', 'ko', 'kr', 'ks',
    'ku', 'kv', 'kw', 'ky', 'la', 'lb', 'lg', 'li', 'ln', 'lo', 'lt', 'lu', 'lv', 'mg', 'mh',
    'mi', 'mk', 'ml', 'mn', 'mo', 'mr', 'ms', 'mt', 'my', 'na', 'nb', 'nd', 'ne', 'ng', 'nl',
    'nn', 'no', 'nr', 'nv', 'ny', 'oc', 'oj', 'om', 'or', 'os', 'pa', 'pi', 'pl', 'ps', 'pt',
    'qu', 'rm', 'rn', 'ro', 'ru', 'rw', 'sa', 'sc', 'sd', 'se', 'sg', 'sh', 'si', 'sk', 'sl',
    'sm', 'sn', 'so', 'sq', 'sr', 'ss', 'st', 'su', 'sv', 'sw', 'ta', 'te', 'tg', 'th', 'ti',
    'tk', 'tl', 'tn', 'to', 'tr', 'ts', 'tt', 'tw', 'ty', 'ug', 'uk', 'ur', 'uz', 've', 'vi',
    'vo', 'wa', 'wo', 'xh', 'yi', 'yo', 'za', 'zh', 'zu', 'fil'];

export const TRANSLATE_LANUAGES = ['af', 'sq', 'am', 'ar', 'hy', 'az', 'eu', 'be', 'bn', 'bs', 'bg', 'ca', 'ceb', 'zh', 'zh-TW',
    'co', 'hr', 'cs', 'da', 'nl', 'en', 'eo', 'et', 'fi', 'fr', 'fy', 'gl', 'ka', 'de', 'el', 'gu', 'ht', 'ha', 'haw', 'he', 'hi', 'hmn',
    'hu', 'is', 'ig', 'id', 'ga', 'it', 'ja', 'jv', 'kn', 'kk', 'km', 'rw', 'ko', 'ku', 'ky', 'lo', 'lv', 'lt', 'lb', 'mk', 'mg', 'ms',
    'ml', 'mt', 'mi', 'mr', 'mn', 'my', 'ne', 'no', 'ny', 'or', 'ps', 'fa', 'pl', 'pt', 'pa', 'ro', 'ru', 'sm', 'gd', 'sr', 'st', 'sn',
    'sd', 'si', 'sk', 'sl', 'so', 'es', 'su', 'sw', 'sv', 'tl', 'tg', 'ta', 'tt', 'te', 'th', 'tr', 'tk', 'uk', 'ur', 'ug', 'uz', 'vi', 'cy', 'xh', 'yi', 'yo', 'zu', 'fil'];

// 翻译后需要保留空格的语言
export const LANGUAGES_WITHOUT_SPACES = ['zh', 'zh-TW', 'ja', 'th', 'lo', 'km', 'my'];

export const RULE = [];

export const SHOP_KEY = 'shop_s_k';

export const SHOP_PRODUCT_SYNC_KEY = 's_p_sync_';

export const FORM_SHOP_PRODUCT_SYNC_KEY = 'f_s_p_sync_';

export const MARKETING_TIMEZONE_KEY = 'ss_marketing_tz';

// 不保存到本地的导航记录
export const NO_SAVE_LOCAL_NAV = [
    'error401',
    'error404',
    'noProject',
    'home',
    'authShop',
    'guideShop',
    'shareVerify',
    'shareLinkChannelAnalysis',
    'feeReceipt',
    'shareVerifyChannel',
    'shareVerifyCustomer',
    'shareAnalysis',
    'shareLinkChannelAnalysisOld',
    'shareVerifyOld',
    'shareLinkCustomerAnalysis',
    'idle',
];

// 不能执行"用户登出"的页面
export const NO_LOGOUT_PAGE = [
    'privacy',
    'invite',
    'open',
    'openInfo',
    'payresult',
    'authShop',
    'authThird',
    'bigcommerceTransit',
    'automatedLinks',
    'authWorkWeixin',
    'authWorkWeixinTest',
    'activity',
    'shareVerify',
    'shareVerifyChannel',
    'shareVerifyCustomer',
    'shareLinkChannelAnalysis',
    'shareAnalysis',
    'shareLinkChannelAnalysisOld',
    'shareVerifyOld',
    'shareLinkCustomerAnalysis',
];

// 套餐
export const PACKAGE_LIST = ['basic', 'professional', 'commercial', 'corporate', 'pro'];

export const BROADCAST_SELECT_CHANNEL = '7';

// whatsapp gupshup 模板支持的语言
export const GUPSHUP_LANG = [
    'af', 'sq', 'ar', 'az', 'bn', 'bg', 'ca', 'zh_CN', 'zh_HK', 'zh_TW',
    'hr', 'cs', 'da', 'nl', 'en', 'en_GB', 'en_US', 'et', 'fil', 'fi',
    'fr', 'ka', 'de', 'el', 'gu', 'ha', 'he', 'hi', 'hu', 'id', 'ga', 'it',
    'ja', 'kn', 'kk', 'rw_RW', 'ko', 'ky_KG', 'lo', 'lv', 'lt', 'mk', 'ms',
    'ml', 'mr', 'nb', 'fa', 'pl', 'pt_BR', 'pt_PT', 'pa', 'ro', 'ru', 'sr',
    'sk', 'sl', 'es', 'es_AR', 'es_ES', 'es_MX', 'sw', 'sv', 'ta', 'te', 'th',
    'tr', 'uk', 'ur', 'uz', 'vi', 'zu'];

// Messenger 通知类模板 支持的语言
export const MESSENGER_LANG = [
    'af', 'sq', 'ar', 'az', 'bn', 'bg', 'ca', 'zh_CN', 'zh_HK', 'zh_TW',
    'hr', 'cs', 'da', 'nl', 'en', 'en_GB', 'en_US', 'et', 'fil', 'fi',
    'fr', 'ka', 'de', 'el', 'gu', 'ha', 'he', 'hi', 'hu', 'id', 'ga', 'it',
    'ja', 'kn', 'kk', 'rw_RW', 'ko', 'ky_KG', 'lo', 'lv', 'lt', 'mk', 'ms',
    'ml', 'mr', 'nb', 'fa', 'pl', 'pt_BR', 'pt_PT', 'pa', 'ro', 'ru', 'sr',
    'sk', 'sl', 'es', 'es_AR', 'es_ES', 'es_MX', 'sw', 'sv', 'ta', 'te', 'th',
    'tr', 'uk', 'ur', 'uz', 'vi', 'zu', 'mn'];

// OSS解密key
export const OSS_KEY = 'jkgh54jh7k5hg2g3j35wjh34jkh55jhh';

// 保存用户登录密码key
export const SS_LOGIN_INFO_KEY = 'SS_LOCAL_LOGIN_INFORMATION';
export const SS_REMEMBER_PASSWORD_KEY = 'SS_REMEMBER_PWD';

/**
 * 分享链接存储share-token key
 */
export const SS_SHARE_CHANNEL_ACCESS_TOKEN_KEY = 'SS_SHARE_CHANNEL_ACCESS_TOKEN_KEY';

// 不支持压缩的格式
export const UNCOMPRESSED_FORMAT_TYPE = ['image/gif'];

// 渠道枚举
export const CHANNEL_ENUM: {
    [key in Chat.channel | Chat.otherChannel]: string;
} = {
    1: 'messenger',
    2: 'plugin',
    3: 'email',
    4: 'telegram',
    5: 'instagram',
    6: 'line',
    7: 'whatsapp',
    8: 'fb_comment',
    9: '',
    10: 'slack',
    11: 'work_weixin_bot',
    12: 'individual_whatsapp',
    13: 'ins_comment',
    14: 'work_weixin',
    15: 'telegram_app',
    16: 'tiktok_app',
    17: 'tiktok_app_comment',
    18: 'vkontakte',
    19: 'zalo',
    20: 'tiktok_business',
    21: 'tiktok_business_comment',
    22: 'youtube',
    23: 'wechat',
    24: 'line_app',
    25: 'sms',
    26: 'twitter_app',
};

/** 第三方SSO登录信息 key */
export const THIRD_PARTY_SSO_K_I = 'THIRD_PARTY_SSO_K_I';

/** 系统提示音 */
export const PROMPT_SOUNDS = [
    { id: '1', src: 'https://client.salesmartly.com/setting/sounds/ling.mp3' },
    { id: '2', src: 'https://client.salesmartly.com/setting/sounds/ling_1.mp3' },
    { id: '3', src: 'https://client.salesmartly.com/setting/sounds/ling_2.mp3' },
    { id: '4', src: 'https://client.salesmartly.com/setting/sounds/ling_3.mp3' },
    { id: '5', src: 'https://client.salesmartly.com/setting/sounds/ling_4.mp3' },
    { id: '6', src: 'https://client.salesmartly.com/setting/sounds/ling_5.mp3' },
    { id: '7', src: 'https://client.salesmartly.com/setting/sounds/ling_6.mp3' },
    { id: '8', src: 'https://client.salesmartly.com/setting/sounds/ling_7.mp3' },
];

/** 跳转新版界面的白名单 */
export const REDIRECT_WHITE_LIST = [
    'automatedLinks',
    'feeReceipt',
    'share',
    'shareLinkChannelAnalysisOld',
    'shareVerifyOld',
    'shareAnalysis',
    'shareVerifyChannel',
    'shareVerifyCustomer',
    'shareLinkChannelAnalysis',
    'shareLinkCustomerAnalysis',
    'authSSO',
    'authresult',
    'auth_result',
];
